module.exports = __webpack_public_path__ + "static/justjoinit.fa100822.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/interviews/justjoinit.jpg
// module id = 692
// module chunks = 263791100135453